module.exports = __webpack_public_path__ + "static/media/policeman.c2303966.svg";